import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Link extends Component {
  render() {
    const { children, ...otherProps } = this.props;
    return (
      <a
        ref={(c) => { this.link = c; }}
        onMouseLeave={() => this.link.blur()}
        {...otherProps}
      >
        {children}
      </a>
    );
  }
}

Link.propTypes = {
  children: PropTypes.node,
};

Link.defaultProps = {
  children: null,
};
